/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodforfriends2Inputs */

const en_goodforfriends2 = /** @type {(inputs: Goodforfriends2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friends`)
};

const de_goodforfriends2 = /** @type {(inputs: Goodforfriends2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freunde`)
};

/**
* | output |
* | --- |
* | "Friends" |
*
* @param {Goodforfriends2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforfriends2 = /** @type {((inputs?: Goodforfriends2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforfriends2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforfriends2(inputs)
	return de_goodforfriends2(inputs)
});
export { goodforfriends2 as "goodForFriends" }